import React from "react";

import Lamina28act1img1 from "../images/lamina28act1_1.png";
import Lamina28act1img2 from "../images/lamina28act1_2.png";
import Lamina28act1img3 from "../images/lamina28act1_3.png";
import Lamina28act1img4 from "../images/lamina28act1_4.png";
import Lamina28act1img5 from "../images/lamina28act1_5.png";
import Lamina28act1img6 from "../images/lamina28act1_6.png";
import Lamina28act1img7 from "../images/lamina28act1_7.png";
import Lamina28act1img8 from "../images/lamina28act1_8.png";
import Lamina28act1img9 from "../images/lamina28act1_9.png";
import Lamina28act1img10 from "../images/lamina28act1_10.png";
import Lamina28act2img1 from "../images/lamina28act2_1.png";
import Lamina28act2img2 from "../images/lamina28act2_2.png";
import Lamina28nota from "../images/lamina28nota.png";
import Lamina28act2 from "../images/lamina28act2.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  purple: {
    color: theme.palette.purple.main,
    borderColor: theme.palette.purple.main,
  },
  rootOptions: {
    backgroundColor: theme.palette.grey[300],
    fontWeight: 500,
    padding: 20,
    marginBottom: "1em",
  },
  root: {
    "& img": {
      width: "100%",
    },
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "100%",
      },
    },
  },
}));

const Lamina27 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 28: Los símbolos que representan al Perú"
        meta={[
          {
            property: "og:title",
            content: "Lámina 28: Los símbolos que representan al Perú",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "La nación peruana, como otras naciones, tiene plantas, animales, lugares, objetos e incluso comida que la distinguen.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="28" color="purple" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title
          title="Los símbolos que representan al Perú"
          color="purple"
          size="md"
        />
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>
            Observa las siguientes imágenes y coloca los nombres que les
            correspondan.
          </strong>
        </p>
        <Grid container className={classes.root} spacing={1} justify="center">
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img1} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img2} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img3} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img4} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img5} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img6} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img7} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img8} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img9} alt="Actividad" />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <img src={Lamina28act1img10} alt="Actividad" />
          </Grid>
          <Grid item lg={7} md={7} sm={12} xs={12}>
            <img src={Lamina28act2img1} alt="Actividad" />
          </Grid>
          <Grid item lg={5} md={5} sm={8} xs={8}>
            <img src={Lamina28act2img2} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          spacing={4}
          alignItems="center"
          align="center"
          justify="center"
        >
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <img src={Lamina28nota} alt="Nota" />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p style={{ color: "#ec008c", textAlign: "left" }}>
              <strong>
                La nación peruana, como otras naciones, tiene plantas, animales,
                lugares, objetos e incluso comida que la distinguen. Estos son
                símbolos que nos representan. Existen símbolos patrios como la
                bandera, el escudo y el himno nacional; así como símbolos no
                oficiales que nos identifican como nación y son elementos de
                unión para los peruanos.
              </strong>
            </p>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>
            Observa y completa el diálogo con las palabras del recuadro.
          </strong>
        </p>

        <Grid
          container
          align="center"
          justify="center"
          className={classes.rootOptions}
        >
          <Grid item lg={2} md={2} sm={3} xs={6}>
            himno
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            escudo
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            independencia
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            símbolos
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            bandera
          </Grid>
        </Grid>
        <img src={Lamina28act2} alt="Actividad" style={{ width: "100%" }} />
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-28.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.purple }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 28: Los símbolos que representan al Perú'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        anterior="¿Qué hace el poder judicial?"
        anteriorEnlace="/lamina-1-27"
      />
    </>
  );
};

export default Lamina27;
